import { forwardRef } from 'react';
import HammerIcon from '@assets/img/icons/hammer.svg?react';
import { type HTMLMotionProps, motion } from 'framer-motion';

const HammerMotionIcon = forwardRef<HTMLDivElement, HTMLMotionProps<'div'>>(
  (props, ref) => {
    return (
      <motion.div ref={ref} {...props}>
        <HammerIcon className="size-full" />
      </motion.div>
    );
  },
);

export { HammerMotionIcon };
